<template>
  <div class="annualMeetingPage">
    <heads class="navShow"></heads>
    <div class="header-banner">
      <div class="swiper-wrapper" v-loading="swiperLoading">
        <swiper
          v-if="bannerArray.length > 0"
          :options="swiperOptionTop"
          class="gallery-top"
          ref="swiperTop"
        >
          <swiper-slide
            class="slide-1"
            v-for="(item, index) in bannerArray"
            :key="index"
          >
            <div class="swiper-topic">
              <span>{{ item.title }}</span>
              <p>{{ item.description }}</p>
              <div
                class="topic-img"
                v-bind:style="{
                  backgroundImage: 'url(' + '\'' + item.path + '\'' + ')',
                }"
              ></div>
              <div class="topic-img-cover"></div>
            </div>
          </swiper-slide>
          <div
            class="swiper-button-next swiper-button-white"
            slot="button-next"
          ></div>
          <div
            class="swiper-button-prev swiper-button-white"
            slot="button-prev"
          ></div>
          <!-- <div class="swiper-pagination" slot="pagination"></div> -->
        </swiper>
      </div>
      <button @click="showCustomForm()">免费定制</button>
    </div>
    <!--年会产品-->
    <annualMeetingProduct :message="annualMeetingProductMessage" />
    <!--我们正在服务的企业-->
    <cooperativeEnterprise :message="cooperativeEnterpriseMessage" />
    <!--服务过程-->
    <serviceProcess />
    <!--服务内容-->
    <serviceContent :message="serviceContentMessage" />
    <!--更优质的服务选择-->
    <selectReason :message="selectReasonMessage" />
    <homeFoots></homeFoots>
    <homeBottomImage style="z-index:1000"></homeBottomImage>
    <quickContact :message="message"></quickContact>
    <el-dialog :visible.sync="getCustomFormState" width="0%">
      <annualMeetingCustomForm></annualMeetingCustomForm>
    </el-dialog>
  </div>
  <!-- annualMeetingPage end -->
</template>

<script>
import heads from "@/components/comment/heads.vue";
import homeBottomImage from "@/components/comment/homeBottomImage.vue";
import homeFoots from "@/components/comment/homeFoots.vue";
import quickContact from "@/components/comment/quickContact.vue";
import Vue from "vue";
import annualMeetingProduct from "@/components/annualMeeting/annualMeetingProduct.vue";
import annualMeetingCustomForm from "@/components/annualMeeting/annualMeetingCustomForm.vue";
import cooperativeEnterprise from "@/components/annualMeeting/cooperativeEnterprise.vue";
import selectReason from "@/components/annualMeeting/selectReason.vue";
import serviceContent from "@/components/annualMeeting/serviceContent.vue";
import serviceProcess from "@/components/annualMeeting/serviceProcess.vue";
import { fomateDate, handlePicPlusPre } from "@/util/util.js";
import wxShare from "@/common/wx_share.js";
// import s1_webp from "../../assets"
import axios from "axios";
export default {
  name: "annualMeetingPage",
  data() {
    return {
      placeholderText: "查立项",
      titleIndex: 0,
      downloadNavArray: [],
      requireDialogVisible: false,
      message: {
        type: 2,
      },
      swiperOptionTop: {
        autoplay: true,
        loop: true,
        slidesPerview: "auto",
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },

        swiperLoading: false,
      },
      swiperLoading: false,
      // swiperOptionThumbs: {
      //   autoplay: true,
      //   direction: "vertical",
      //   spaceBetween: 5,
      //   slidesPerView: "auto",
      //   centeredSlides: true,
      //   touchRatio: 0.2,
      //   loop: true,
      //   slidesPerview: "auto",
      //   observer: true, //修改swiper自己或子元素时，自动初始化swiper
      //   observeParents: true, //修改swiper的父元素时，自动初始化swiper
      //   slideToClickedSlide: true
      // },
      searchVal: "",
      bannerArray: [],
      show: false,
      top: "",
      pageArray: [],
      radio: "1",
      centerDialogVisible: true,

      //模块数据
      generalList: [],
      specialList: "",
      showCard: false,

      // lxq

      // --- 传递给组件的参数
      selectReasonMessage: [],
      cooperativeEnterpriseMessage: [],
      annualMeetingProductMessage: [],
      serviceContentMessage: [],

      // --- 传递给组件的参数
    };
  },
  components: {
    heads,
    homeFoots,
    quickContact,
    annualMeetingProduct,
    cooperativeEnterprise,
    selectReason,
    serviceContent,
    serviceProcess,
    annualMeetingCustomForm,
    homeBottomImage
  },
  computed: {
    getScrolltop() {
      let _this = this;
      window.addEventListener("scroll", () => {
        _this.top =
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          window.pageYOffset;
      });
      return _this.top > 300;
    },
    // 获取免费定制弹出框的值
    getCustomFormState() {
      return this.$store.state.annualMeetingCustomState;
    },
    // 前置图片路径
    getPreUrl() {
      return this.$store.state.picPreUrl;
    },
    // 获取站点城市id
    getLocationSiteCityId() {
      return this.$store.state.locationSiteCity
        ? this.$store.state.locationSiteCity
        : 5;
    },
  },
  watch: {},
  methods: {
    handlePicPlusPre,
    showCustomForm() {
      this.$store.commit("saveAnnualMeetingCustomState", true);
    },
    // 获取头部广告位置
    getBanner(positionId) {
      console.log("getAdPosition-Start-year");
      const params = {
        positionId: positionId,
        cityId: this.getLocationSiteCityId,
      };
      axios
        .get(`/api/adm/list`, {
          params,
          cityId: this.getLocationSiteCityId,
        })
        .then((res) => {
          console.log(res);
          if (res.data && res.data.code == 200) {
            this.bannerArray = res.data.adList;
            if (this.bannerArray) {
              this.bannerArray.forEach((banner) => {
                banner.path = handlePicPlusPre(banner.path);
              });
            }
          }
        });
    },
    showSelectContent() {
      console.log("showSelectContent");
      this.isSelectContent = !this.isSelectContent;
      if (this.isSelectContent) {
      } else {
      }
    },
    // 搜索一级标签选中
    selectTitleMethod(index) {
      this.selectTitleNum = index;
      this.selectContentArray = this.selectTitle[index].child;
    },
    // 搜索二级标签选中
    selectContentMethod(id) {
      // 跳转
    },
  },
  mounted() {
    this.getBanner(8);
    // 微信分享
    if (wxShare.is_wx()) {
      wxShare.wxReWriteShare(
        `${this.$store.state.defaultTitle}`,
        `${this.$store.state.defaultDesc}`,
        `${window.location.href}`,
        `${this.$store.state.defaultPic}`
      );
    }
  },
  created() {
    // this.swiperLoading = true;
  },
};
</script>

<style scoped>
.swiper-container {
  background-color: #fff;
}
.swiper-slide {
  background-size: cover;
  background-position: center;
  width: 100% !important;
}
.swiper-topic {
  height: 460px;
  width: 100%;
  position: relative;
}
.swiper-topic span,
.swiper-topic p {
  position: absolute;
  display: inline-block;
  width: 700px;
  left: 50%;
  margin-left: -400px;
  color: #ffebbf;
  text-shadow: 0 2px 0 rgb(0 0 0 / 30%);
  text-align: left;
  z-index: 1000;
}
.swiper-topic span {
  top: 80px;
  font-weight: 700;
  font-size: 44px;
  z-index: 1000;
}
.swiper-topic p {
  top: 164px;
  font-size: 20px;
}
.swiper-topic .topic-img {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  z-index: 1;
}
.swiper-topic .topic-img-cover {
  width: 100%;
  height: 100%;
  position: absolute;
  background-repeat: no-repeat;
  z-index: 999;
  background: #0005;
  top: 0px;
}
.headnavS {
  display: none;
}
.navS {
  opacity: 0;
}
.navShow {
  animation: rainbow 0.8s linear;
  /* Safari and Chrome: */
  -webkit-animation: rainbow 0.8s linear;
}
@-moz-keyframes rainbow {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-o-keyframes rainbow {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-webkit-keyframes rainbow {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes rainbow {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.gallery-top {
  height: 100% !important;
  width: 100%;
}
.gallery-top .slide-1 {
  background-position: center center;
  background-size: 100% 100%;
  background-repeat: no-repeat;

  position: relative;
}
.gallery-top .slide-1 a {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.gallery-thumbs {
  position: absolute;
  right: 50px;
  top: 150px;
  width: 100px;
  height: 190px;
  padding: 0 5px;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 5px;
}
/* .gallery-thumbs .swiper-slide {
  width: 100%;
  height: 50px;
  opacity: 0.4;
}
.gallery-thumbs .swiper-slide img {
  width: 80px;
  height: 50px;
}
.gallery-thumbs .swiper-slide-active {
  opacity: 1;
}*/
</style>

<style scoped>
.header-banner {
  position: relative;
  height: 460px;
  background: #000;
}
.header-banner > button {
  left: 50%;
  margin-left: -400px;
  bottom: 107px;
  z-index: 1000;
  outline: none;
  border: none;
  cursor: pointer;
  position: absolute;
  width: 156px;
  height: 52px;
  font-weight: 700;
  background: #fe4b44;
  border-radius: 6px;
  font-size: 16px;
  color: #ffebbf;
}
.swiper-wrapper {
  position: relative;
  height: 460px;
  background: #000;
}
.swiper-wrapper >>> .swiper-pagination-bullet {
  background: #e4e4e4 !important;
}
.swiper-wrapper >>> .swiper-pagination-bullet-active {
  background: #000000 !important;
}
.swiper-pagination >>> span {
  width: 12px !important;
  height: 12px !important;
}

/* 第一面横幅下方描述 */
@media screen and (min-width: 1060px) {
  .second-part {
    width: 1060px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1060px) {
  .annualMeetingPage .annualMeetingPage-search-bar,
  .second-part {
    width: 100%;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/annualMeeting/annualMeetingPage.vue